import { useMemo } from 'react'
import { useReadPepperContract } from '../pepper-contract/useReadPepperContract'
import { msToHours } from '@/utils/datetime/msToUnit'

type Props = {
	/** Watches the total supply every 3 seconds */
	watch?: boolean
}

export function usePepperSupply({ watch = false }: Props = {}) {
	const totalSupply = useReadPepperContract({
		functionName: 'totalSupply',
		query: {
			staleTime: msToHours(6),
			...(watch && { refetchInterval: 3000 })
		}
	})

	const maxSupply = useReadPepperContract({
		functionName: 'MAX_SUPPLY',
		query: {
			staleTime: Infinity
		}
	})

	return useMemo(
		() => ({
			error: totalSupply.error || maxSupply.error,
			totalSupply,
			maxSupply
		}),
		[totalSupply, maxSupply]
	)
}
